<ng-container *ngIf="vm$ | async as vm">
    <div class="page-wrap" *ngIf="vm.isAllowed">
        <div class="container">
            <div class="row centered">
                <div class="logo-center" style="width: 100%; text-align: center;">
                    <div style="overflow: hidden;">
                        <div class="show-overflow">
                            <div class="school-logo no-content" aria-hidden="false">
                                <!-- Hidden Image Tag is an accessibility work around I Tried getting rid of the div and tried using content: url(path/to/image); in the CSS and IE wasn't liking that-->
                                <img src="" aria-hidden="false" alt="School Logo" hidden />
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-sm-offset-3 col-sm-6">
                    <div id="create-account-panel">
                        <section>
                            <form [formGroup]="createAccountFormGroup" (ngSubmit)="onSave()" novalidate *ngIf="true" class="form-entry form-wrap">
                                <div class="form-top">
                                    <div class="fa fa-user" aria-hidden="true"></div>
                                    <h1>Create Account</h1>
                                </div>
                                <div class="form-entry">
                                    <div *ngIf="vm.formSubmitError.length > 0"
                                         class="form-required"
                                         role="alert"
                                         id="form-submit-error">
                                        <div *ngFor="let error of vm.formSubmitError">
                                            {{error}}
                                        </div>
                                    </div>
                                    <div class="form-required align-right">* Required</div>
                                    <div class="form-group">
                                        <label for="email" style="display: inline-block"><span class="form-required" aria-hidden="true">*</span> Preferred Email</label>
                                        <input class="form-control"
                                               id="email"
                                               name="email"
                                               type="text"
                                               formControlName="email"
                                               ssValidateEqual="confirmEmail"
                                               ssEmailDomainValidator
                                               [emailDomainValidatorConfig]='{allowedEmailDomains: vm.allowedEmailDomains}'
                                               reverse="true"
                                               ssAutoFocus />
                                        <div *ngIf="createAccountFormGroup.get('email')!.errors && createAccountFormGroup.get('email')!.touched">
                                            <div *ngFor="let message of getErrorMessages('email'); index as i">
                                                <cl-error-validation-message id="email-error-{{i}}"
                                                                             message="{{message}}">
                                                </cl-error-validation-message>
                                                <br *ngIf="i > 0" />
                                            </div>
                                        </div>
                                    </div>
                                    <div class="form-group">
                                        <label for="confirmEmail" style="display: inline-block"><span class="form-required" aria-hidden="true">*</span> Confirm Email</label>
                                        <input class="form-control"
                                               id="confirmEmail"
                                               formControlName="confirmEmail"
                                               name="confirmEmail"
                                               type="text"
                                               ssValidateEqual="email"
                                               reverse="false" />
                                        <div *ngIf="createAccountFormGroup.get('confirmEmail')!.errors && createAccountFormGroup.get('confirmEmail')!.touched">
                                            <div *ngFor="let message of getErrorMessages('confirmEmail'); index as i">
                                                <cl-error-validation-message id="confirmEmail-error-{{i}}"
                                                                             message="{{message}}">
                                                </cl-error-validation-message>
                                                <br *ngIf="i > 0" />
                                            </div>
                                        </div>
                                    </div>
                                    <div class="form-group">
                                        <label for="username" style="display: inline-block">
                                            <span class="form-required" aria-hidden="true">*</span> Choose Username
                                            <cl-tooltip [message]="'
                                             <div>
                                            When creating your user name, you can use the following characters:
                                            <ul>
                                                <li>Upper case letters</li>
                                                <li>Lower case letters</li>
                                                <li>Numbers</li>
                                                <li>&#8220;&#64;&#8221;, &#8220;&#95;&#8221;, &#8220;.&#8221;, and &#8220;-&#8221;</li>
                                            </ul>
                                            Your user name must be between 8 and 64 characters long.
                                            </div>'">
                                            </cl-tooltip>
                                        </label>
                                        <input class="form-control"
                                               id="username"
                                               name="username"
                                               type="text"
                                               formControlName="username" />
                                        <div *ngIf="createAccountFormGroup.get('username')!.errors && createAccountFormGroup.get('username')!.touched">
                                            <div *ngFor="let message of getErrorMessages('username'); index as i">
                                                <cl-error-validation-message id="username-error-{{i}}"
                                                                             message="{{message}}">
                                                </cl-error-validation-message>
                                                <br *ngIf="i > 0" />
                                            </div>
                                        </div>
                                    </div>
                                    <div class="form-group">
                                        <label for="password" style="display: inline-block">
                                            <span class="form-required" aria-hidden="true">*</span> Create Password
                                            <cl-tooltip [message]="'<div>
                                            When creating your password, you must have <b>at least 1</b> of each of the following characters:<ul><li>Upper case letters</li><li>Lower case letters</li><li>Numbers</li></ul>Your password must be at least 8 characters long.
                                        </div>'"></cl-tooltip>
                                        </label>
                                        <input class="form-control"
                                               id="password"
                                               name="password"
                                               type="password"
                                               formControlName="password"
                                               ssValidateEqual="confirmPassword"
                                               reverse="true" />
                                        <div *ngIf="createAccountFormGroup.get('password')!.errors && createAccountFormGroup.get('password')!.touched">
                                            <div *ngFor="let message of getErrorMessages('password'); index as i">
                                                <cl-error-validation-message id="password-error-{{i}}"
                                                                             message="{{message}}">
                                                </cl-error-validation-message>
                                                <br *ngIf="i > 0" />
                                            </div>
                                        </div>
                                    </div>
                                    <div class="form-group">
                                        <label for="confirmPassword"
                                               style="display: inline-block">
                                            <span class="form-required" aria-hidden="true">*</span> Confirm Password
                                        </label>
                                        <input class="form-control"
                                               id="confirmPassword"
                                               name="confirmPassword"
                                               type="password"
                                               formControlName="confirmPassword"
                                               ssValidateEqual="password"
                                               reverse="false" />
                                        <div *ngIf="createAccountFormGroup.get('confirmPassword')!.errors && createAccountFormGroup.get('confirmPassword')!.touched">
                                            <div *ngFor="let message of getErrorMessages('confirmPassword'); index as i">
                                                <cl-error-validation-message id="confirmPassword-error-{{i}}"
                                                                             message="{{message}}">
                                                </cl-error-validation-message>
                                                <br *ngIf="i > 0" />
                                            </div>
                                        </div>
                                    </div>
                                    <div class="form-group">
                                        <label for="firstName"
                                               style="display: inline-block">
                                            <span class="form-required" aria-hidden="true">*</span> First Name
                                        </label>
                                        <input class="form-control"
                                               id="firstName"
                                               name="firstName"
                                               formControlName="firstName"
                                               type="text" />
                                        <div *ngIf="createAccountFormGroup.get('firstName')!.errors && createAccountFormGroup.get('firstName')!.touched">
                                            <div *ngFor="let message of getErrorMessages('firstName'); index as i">
                                                <cl-error-validation-message id="firstName-error-{{i}}"
                                                                             message="{{message}}">
                                                </cl-error-validation-message>
                                                <br *ngIf="i > 0" />
                                            </div>
                                        </div>
                                    </div>
                                    <div class="form-group">
                                        <label for="lastName"
                                               style="display: inline-block">
                                            <span class="form-required" aria-hidden="true">*</span> Last Name
                                        </label>
                                        <input class="form-control"
                                               id="lastName"
                                               name="lastName"
                                               type="text"
                                               formControlName="lastName" />
                                        <div *ngIf="createAccountFormGroup.get('lastName')!.errors && createAccountFormGroup.get('lastName')!.touched">
                                            <div *ngFor="let message of getErrorMessages('lastName'); index as i">
                                                <cl-error-validation-message id="lastName-error-{{i}}"
                                                                             message="{{message}}">
                                                </cl-error-validation-message>
                                                <br *ngIf="i > 0" />
                                            </div>
                                        </div>
                                    </div>
                                    <div class="form-group">
                                        <label for="dateOfBirth"
                                               style="display: inline-block">
                                            <span class="form-required" aria-hidden="true">*</span> Date of Birth
                                        </label>
                                        <kendo-datepicker class="form-control no-border"
                                                          name="dateOfBirth"
                                                          id="dateOfBirth"
                                                          formControlName="dateOfBirth"
                                                          [max]="vm.maxDate"
                                                          [focusedDate]="vm.maxDate">
                                        </kendo-datepicker>
                                        <div *ngIf="createAccountFormGroup.get('dateOfBirth')!.errors && createAccountFormGroup.get('dateOfBirth')!.touched">
                                            <div *ngFor="let message of getErrorMessages('dateOfBirth'); index as i">
                                                <cl-error-validation-message id="dateOfBirth-error-{{i}}"
                                                                             message="{{message}}">
                                                </cl-error-validation-message>
                                                <br *ngIf="i > 0" />
                                            </div>
                                        </div>
                                    </div>
                                    <div class="form-group" *ngIf="vm.studentIdEditable">
                                        <label for="studentId" style="display: inline-block">
                                            <span *ngIf="vm.studentIdRequired" class="form-required" aria-hidden="true">*</span> Student ID
                                        </label>
                                        <input class="form-control"
                                               id="studentId"
                                               name="studentId"
                                               type="text"
                                               formControlName="studentId" />
                                        <div *ngIf="createAccountFormGroup.get('studentId')!.errors && createAccountFormGroup.get('studentId')!.touched">
                                            <div *ngFor="let message of getErrorMessages('studentId'); index as i">
                                                <cl-error-validation-message id="studentId-error-{{i}}"
                                                                             message="{{message}}">
                                                </cl-error-validation-message>
                                                <br *ngIf="i > 0" />
                                            </div>
                                        </div>
                                    </div>
                                    <div class="form-group">
                                        <div class="inline-block">
                                            <i>Provide a phone number to subscribe to mobile phone text messages for account updates.<br />(Standard text message charges apply)</i>
                                            <br /><br />
                                        </div>
                                        <label for="phoneNumber"> Phone Number</label>
                                        <kendo-maskedtextbox [mask]="'(000)000-0000'"
                                                             id="phoneNumber"
                                                             type="text"
                                                             class="inline-block"
                                                             formControlName="phoneNumber"
                                                             name="phoneNumber">
                                        </kendo-maskedtextbox>
                                        <div *ngIf="createAccountFormGroup.get('phoneNumber')!.errors && createAccountFormGroup.get('phoneNumber')!.touched">
                                            <div *ngFor="let message of getErrorMessages('phoneNumber'); index as i">
                                                <cl-error-validation-message id="phoneNumber-error-{{i}}"
                                                                             message="{{message}}">
                                                </cl-error-validation-message>
                                                <br *ngIf="i > 0" />
                                            </div>
                                        </div>
                                    </div>
                                    <div class="checkbox" style="margin-bottom:0px;">
                                        <label>
                                            <input type="checkbox"
                                                   id="termsAccepted"
                                                   name="termsAccepted"
                                                   formControlName="termsAccepted" />
                                            <span class="form-required" aria-hidden="true">*</span> I accept the <a id="termsLink" href="javascript:void(0);" (click)="vm.termsVisible=true">privacy policy</a> and <a id="endUserLink" target="_blank" href="/termsandconditions">end user agreement</a>
                                        </label>
                                    </div>
                                    <div *ngIf="createAccountFormGroup.get('termsAccepted')!.errors && createAccountFormGroup.get('termsAccepted')!.touched">
                                        <div *ngFor="let message of getErrorMessages('termsAccepted'); index as i">
                                            <cl-error-validation-message id="termsAccepted-error-{{i}}"
                                                                         message="{{message}}">
                                            </cl-error-validation-message>
                                            <br *ngIf="i > 0" />
                                        </div>
                                    </div>
                                    <div class="form-group align-right">
                                        <input id="create-account-form-submit-button" class="btn btn-primary" type="submit" value="Create Account" [disabled]="!createAccountFormGroup.valid" />
                                    </div>
                                </div>
                                <div class="form-bottom">
                                    By using the site, you agree to the <a [target]="'_blank'" [href]="vm.pathToTerms">Terms of Use.</a>
                                    <br>
                                    Already have an account? <a href="/">Login.</a>
                                </div>
                            </form>
                        </section>
                    </div>
                </div>
            </div>
        </div>
        <div class="site-footer">
            <div>Version {{vm.version}} - <a target="_blank" href="/termsandconditions">End User Agreement</a></div>
        </div>
        <style>
            #termsModalBody {
                max-height: 80vh;
                overflow-y: scroll;
            }

            @media (min-width: 768px) {
                #termsModalBody {
                    max-height: 70vh;
                    max-width: 80vh;
                }
            }
        </style>
        <kendo-dialog title="Privacy Policy" *ngIf="vm.termsVisible" (close)="vm.termsVisible=false">
            <div id="termsModalBody" [innerHtml]="vm.terms | safe: 'html'"></div>
            <kendo-dialog-actions layout="end">
                <button id="terms-modal-accept" class="btn btn-default" (click)="vm.termsVisible=false">Close</button>
            </kendo-dialog-actions>
        </kendo-dialog>
    </div>
</ng-container>